import { useEffect } from 'react';
import isClient from 'commons/isClient';

const useSetCSSVariables = variablesToUpdate => {
  useEffect(() => {
    Object.entries(variablesToUpdate).forEach(([key, value]) => {
      if (isClient()) document.documentElement.style.setProperty(key, value);
    });
  }, [variablesToUpdate]);
};

export default useSetCSSVariables;
